//updated by dolphin on 2/20/2026, 8:55:32 PM.

"use strict";
const API = {
  "base": {
    "login": {
      "login": "/login",
      "refresh": "/system/auth/user/refresh",
      "autoLogin": "/login/autoLogin/{id}",
      "register": "/login/register",
      "forgetPassword": "/login/forgetPassword",
      "getImageCode": "/login/getImageCode"
    }
  },
  "system": {
    "auth": {
      "user": { "@extend": "list", "changePwd": "@/changePwd", "findStaff": "@/findStaff", "listStaff": "@/listStaff", "syncLdap": "@/syncLdap" },
      "role": { "@extend": "list", "setDefaultRole": "@/setDefaultRole" },
      "org": { "@extend": "tree" }
    },
    "tool": {
      "file": { "@extend": "list", "qr": "@/qr/", "base64": "@/base64" },
      "mail": { "@extend": "list", "send": "/system/tool/mail/send" },
      "job": {
        "@extend": "list",
        "jobMethods": "@/getJobList",
        "start": "@/start/{id}",
        "stop": "@/stop/{id}",
        "run": "@/run/{id}",
        "reset": "@/reset/{id}",
        "clearLog": "@/clearLog/{id}",
        "logList": "/system/tool/jobLog/list",
        "getConfig": "@/getConfig/{func}"
      },
      "identifyingCode": { "@extend": "list", "generate": "@/generate" },
      "thirdToken": { "@extend": "list" },
      "shortUrl": { "@extend": "list" },
      "exportTask": { "@extend": "list" },
      "jobPermission": { "@extend": "list" },
      "tcpServer": { "@extend": "list", "getTcpServerType": "@/getTcpServerType" },
      "increment": { "@extend": "list", "getNext": "@/getNext" }
    },
    "dict": { "@extend": "list" },
    "notice": {
      "noticeConfig": { "@extend": "list", "updateNoticeConfig": "@/updateNoticeConfig" },
      "noticeTemplate": { "@extend": "list", "getAllTemplateMap": "@/getAllTemplateMap", "saveTenantTemplate": "@/saveTenantTemplate" },
      "noticeSending": { "@extend": "list", "recallNotice": "@/recallNotice" },
      "noticeRecord": { "@extend": "list" },
      "tenantNoticeRole": { "@extend": "list" }
    },
    "test": { "@extend": "list" },
    "systemConfig": { "@extend": "list", "getConfig": "@/getConfig/{code}", "updateConfig": "@/updateConfig/{code}" },
    "log": { "loginLog": { "@extend": "list" }, "interfaceLog": { "@extend": "list" }, "loginInfo": { "@extend": "list" } },
    "resource": { "@extend": "tree" },
    "lang": { "langConfig": { "@extend": "list" }, "langType": { "@extend": "list" } },
    "layout": { "cell": { "@extend": "list" }, "page": { "@extend": "list" }, "row": { "@extend": "list" } },
    "development": { "gitPull": "@/gitPull", "build": "@/build", "restartServer": "@/restartServer" }
  },
  "tenant": {
    "tenant": { "@extend": "list", "createTenant": "@/createTenant" },
    "location": { "@extend": "tree" },
    "dateRule": { "@extend": "list", "batchCreate": "@/batchCreate" },
    "version": { "@extend": "list" },
    "tenantImageType": { "@extend": "list" }
  },
  "education": {
    "classification": { "@extend": "list" },
    "grade": { "@extend": "list" },
    "classes": { "@extend": "list" },
    "term": { "@extend": "list", "copyTeaching": "@/copyTeaching", "switchTerm": "@/switchTerm" },
    "student": { "@extend": "list" }
  },
  "subject": {
    "subject": { "@extend": "list" },
    "scoreLevel": { "@extend": "list" },
    "scoreRate": { "@extend": "list" },
    "teaching": {
      "@extend": "list",
      "getTeachingConfig": "@/getTeachingConfig",
      "addTeachingTeacher": "@/addTeachingTeacher",
      "getGradeTeachingMap": "@/getGradeTeachingMap"
    },
    "gradeSubject": { "@extend": "list" }
  },
  "report": {
    "report": {
      "getGradeScope": "@/getGradeScope",
      "getGradeReport": "@/getGradeReport",
      "exportGradeReport": "@/exportGradeReport",
      "getGradeSubjectScope": "@/getGradeSubjectScope",
      "getGradeSubjectReport": "@/getGradeSubjectReport",
      "exportGradeSubjectReport": "@/exportGradeSubjectReport",
      "getSubjectScope": "@/getSubjectScope",
      "getSubjectReport": "@/getSubjectReport",
      "exportSubjectReport": "@/exportSubjectReport",
      "getClassesDetailScope": "@/getClassesDetailScope",
      "getClassesDetailReport": "@/getClassesDetailReport",
      "exportClassesDetailReport": "@/exportClassesDetailReport",
      "getGradeDetailScope": "@/getGradeDetailScope",
      "getGradeDetailReport": "@/getGradeDetailReport",
      "exportGradeDetailReport": "@/exportGradeDetailReport",
      "getGradeSubjectDetailScope": "@/getGradeSubjectDetailScope",
      "getGradeSubjectDetailReport": "@/getGradeSubjectDetailReport",
      "exportGradeSubjectDetailReport": "@/exportGradeSubjectDetailReport",
      "getClassesSubjectDetailScope": "@/getClassesSubjectDetailScope",
      "getClassesSubjectDetailReport": "@/getClassesSubjectDetailReport",
      "exportClassesSubjectDetailReport": "@/exportClassesSubjectDetailReport",
      "getSchoolScope": "@/getSchoolScope",
      "getSchoolReport": "@/getSchoolReport",
      "exportSchoolReport": "@/exportSchoolReport",
    },
  },
  "exam": {
    "exam": {
      "@extend": "list",
      "getExamConfig": "@/getExamConfig",
      "getMarkScoreScope": "@/getMarkScoreScope",
      "getMarkClassesScoreData": "@/getMarkClassesScoreData"
    },
    "examSubject": {
      "@extend": "list",
      "addExamGradeSubject": "@/addExamGradeSubject",
      "getExamSubjectConfig": "@/getExamSubjectConfig"
    },
    "examSubjectDetail": { "@extend": "list" },
    "examSubjectLevel": { "@extend": "list", "batchSave": "@/batchSave" },
    "examSubjectRate": { "@extend": "list", "batchSave": "@/batchSave" }
  },
  "score": {
    "score": {
      "@extend": "list",
      "saveClassesScore": "@/saveClassesScore",
      "computedExamSubject": "@/computedExamSubject",
      "computedExamSubjectDetail": "@/computedExamSubjectDetail",
      "computeStudentTotalScore": "@/computeStudentTotalScore",
      "computeAttentionStudent": "@/computeAttentionStudent"
    },
    "scoreDetail": { "@extend": "list" },
    "studentTotalScore": { "@extend": "list" },
    "attentionStudent": { "@extend": "list" },
    "classesScoreReport": { "@extend": "list" },
    "classesLevelReport": { "@extend": "list" },
    "classesRateReport": { "@extend": "list" },
    "classesDetailReport": { "@extend": "list" }
  }
};

export default API
